import React, { Component } from 'react';
import moment from 'moment';
import './AssessmentReport.css';

class AssessmentAddendums extends Component {
	state = {}

	render() { 

		const { addendums } = this.props;
		
		return (
			<div className="AssessmentReport__addendums-container">
				<div className="AssessmentReport__addendums-header">Addendums</div>
				{addendums.map((addendum, i) => (
					<div key={i} className="AssessmentReport__addendums-inner-container">
						<div className="AssessmentReport__addendums-modified">{moment(addendum.lastTouchedDate).format('MMM D, YYYY')}</div>
						<div className="AssessmentReport__addendums-note">{addendum.addendumNote}</div>
					</div>
				))}
			</div>
		);
	}
}
 
export default AssessmentAddendums;


// WEBPACK FOOTER //
// ./src/views/Assessment/AssessmentAddendums.js